import axios from 'axios';
import { setOpenSessionModal } from '../../store/action/session';

const BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL_V2 = process.env.REACT_APP_API_URL_V2;

export let appDispatch = null;

export const setAxiosDispatch = (dispatch) => {
	appDispatch = dispatch;
};

const handleAuthFailure = () => {
	if (appDispatch) {
		appDispatch(setOpenSessionModal());
	}
};

const axiosInstance = axios.create({
	baseURL: BASE_URL,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
		'Cache-Control': 'no-store',
	},
});

export const axiosInstanceV2 = axios.create({
	baseURL: BASE_URL_V2,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
		'Cache-Control': 'no-store',
	},
});

const responseInterceptor = (instance) => {
	instance.interceptors.response.use(
		(response) => response,
		(error) => {
			const status = error?.response?.status;

			// ONLY 401 means the session is no longer valid.
			//
			// 403 was included here too, but the backend returns 403 from
			// checkPermission — i.e. "you're logged in fine, you just lack this
			// permission". Treating it as auth failure popped the
			// "Continue session / Logout" modal whenever a user hit a screen or
			// action their role doesn't allow, which looked like a random session
			// expiry on an otherwise healthy login.
			if (status === 401) {
				handleAuthFailure();
			}

			return Promise.reject(error);
		},
	);
};

responseInterceptor(axiosInstance);
responseInterceptor(axiosInstanceV2);

export default axiosInstance;
